/**
 * @author 彭乐政
 * @description TODO
 * @date 2019/7/12 14:18
 * @version 1.0.0
 */
import TYPES from '../types.js'

export const linkManageState = {
    globalRules: {},
    globalReady: false
}

export const linkManageGetters = {
    [TYPES.GET_LM_GLOBAL_RULES]: state => state.linkManageState.globalRules
}

export const linkManageMutations = {
    [TYPES.SET_LM_GLOBAL_RULES](state, data) {
        state.linkManageState.globalRules = data
    },
    [TYPES.SET_LM_GLOBAL_READY](state, data) {
        state.linkManageState.globalReady = data
    }
}


// WEBPACK FOOTER //
// ./store/modules/m-get-linkmanage.js